"use strict";

import $ from "jquery";
import "kv.cookieconsent";

export function init(scope, settings) {
    if (!scope) {
        return;
    }

    const option = $.extend(
        {
            cookieName: "cookieConsent",
            btn: {
                accept: ".accept",
            },
            transition: {
                show: {
                    type: "fadeIn",
                    duration: 500,
                },
                hide: {
                    type: "fadeOut",
                    duration: 500,
                },
            },
            consentType: "explicit",
        },
        settings,
    );

    if (window.location.search.indexOf("hidethiscookie") === -1) {
        $(scope).cookieConsent(option);
    }
}

export default {
    init,
};
